import { QRCodeSVG } from 'qrcode.react';
import { Copy, Eye } from 'lucide-react';
import { toast } from '@/components/ui/sonner';

interface Props {
  slug: string;
}

export function ShareCard({ slug }: Props) {
  const url = `${window.location.origin}/p/${slug}`;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Ссылка скопирована');
    } catch {
      toast.error('Не получилось скопировать — выделите вручную');
    }
  }

  return (
    <div
      className="card-d"
      style={{ display: 'flex', padding: 14, alignItems: 'center', gap: 16, flexWrap: 'wrap' }}
    >
      <div className="qr">
        <QRCodeSVG value={url} size={64} />
      </div>
      <div style={{ flex: 1, minWidth: 220 }}>
        <div className="t-eyebrow">Публичная ссылка</div>
        <div className="row gap-2" style={{ marginTop: 6, flexWrap: 'wrap' }}>
          <code
            style={{
              fontFamily: 'var(--font-mono)',
              background: 'var(--bg-sunken)',
              padding: '4px 10px',
              borderRadius: 'var(--r-2)',
              border: '1px solid var(--line)',
              fontSize: 13,
            }}
          >
            turneo.app/p/{slug}
          </code>
          <button className="btn btn-sm" onClick={handleCopy}>
            <Copy size={13} />
            Скопировать
          </button>
          <a className="btn btn-sm" href={url} target="_blank" rel="noreferrer">
            <Eye size={13} />
            Открыть
          </a>
        </div>
        <div className="t-xs t-mute" style={{ marginTop: 6 }}>
          Зрители увидят сетку с обновлениями счёта в реальном времени.
        </div>
      </div>
    </div>
  );
}
